import { calculateHeadings, Level } from 'hooks/useTableOfContents'
import Styles from 'common/LinkModal/LinkModal.module.scss'
import { H1, H2, H3, Title } from 'blaze-ui/icons'
import * as React from 'react'
import { Button } from 'blaze-ui/Button'

interface Props {
  text: string
  onLinked: ({ link, text }: { link?: string; text: string }) => void
  onClose: () => void
}

const LevelIcon = ({ level }: { level: Level }) => {
  switch (level) {
    case 0:
      return <Title />
    case 1:
      return <H1 />
    case 2:
      return <H2 />
    case 3:
      return <H3 />
  }
}

export const LinkToHeading = ({ text, onLinked, onClose }: Props) => {
  const headings = calculateHeadings()

  return (
    <>
      <div className={Styles.modalStep2Body}>
        {headings.length === 0 && <div className={Styles.noHeadings}>There are no headings in the document</div>}

        {headings.map(({ blockId, level, title }) => {
          return (
            <Button
              key={blockId}
              variant="tertiary"
              size="lg"
              frontIcon={() => <LevelIcon level={level} />}
              onPress={() => {
                onLinked({ link: `#${blockId}`, text: text === '' && title ? title : text })
                onClose()
              }}
            >
              {title}
            </Button>
          )
        })}
      </div>
    </>
  )
}
